import { Component } from 'react';

import PropTypes from 'prop-types';

import cloneElementWithProps from '../core/cloneElementWithProps';

export default class JobContainer extends Component {
  static propTypes = {
    jobs: PropTypes.array,
    params: PropTypes.object,
  };

  render() {
    const { children, jobs, params } = this.props;
    const { jobURLName } = params;
    const job = jobs.find((job) => job.urlName === jobURLName);
    return cloneElementWithProps(children, {
      ...this.props,
      job,
    });
  }
}
